import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "form5" }
const _hoisted_2 = { class: "form5_left" }
const _hoisted_3 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomeMap = _resolveComponent("CustomeMap")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_image = _resolveComponent("el-image")!
  const _component_VueDraggable = _resolveComponent("VueDraggable")!
  const _component_Plus = _resolveComponent("Plus")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_Map = _resolveComponent("Map")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_form, {
        model: _ctx.form,
        "label-width": "auto",
        style: {"max-width":"600px"},
        "label-position": "top",
        rules: _ctx.rules,
        ref: "ruleForm",
        "status-icon": ""
      }, {
        default: _withCtx(() => [
          (_ctx.dataForm2.mapSelect == '自定义地图')
            ? (_openBlock(), _createBlock(_component_el_form_item, {
                key: 0,
                label: "自定义地图(双击添加或者消除)"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_CustomeMap, {
                    class: "map",
                    ref: "CavMap"
                  }, null, 512)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_el_form_item, { label: "经纬度" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_col, { span: 5 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.lat,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.lat) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 2,
                class: "text-center"
              }),
              _createVNode(_component_el_col, { span: 5 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_input, {
                    modelValue: _ctx.form.lng,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.lng) = $event))
                  }, null, 8, ["modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_el_col, {
                span: 2,
                class: "text-center"
              }),
              _createVNode(_component_el_col, { span: 4 }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.isShow = true))
                  }, {
                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                      _createTextVNode("打开地图")
                    ])),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, {
            label: "地点名称",
            prop: "address"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.address,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.address) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _cache[8] || (_cache[8] = _createElementVNode("h2", null, "关卡位置提示", -1)),
          _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
          _cache[10] || (_cache[10] = _createElementVNode("br", null, null, -1)),
          _createVNode(_component_el_form_item, { label: "地点提示标题" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.addressTipName,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.addressTipName) = $event))
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "地点提示内容" }, {
            default: _withCtx(() => [
              _createVNode(_component_el_input, {
                modelValue: _ctx.form.addressTipContent,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.form.addressTipContent) = $event)),
                type: "textarea"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_el_form_item, { label: "关卡位置提示图" }, {
            default: _withCtx(() => [
              _createVNode(_component_VueDraggable, {
                ref: "el",
                modelValue: _ctx.fileList2,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.fileList2) = $event)),
                class: "content"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.fileList2, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: item.id,
                      class: "lunBo"
                    }, [
                      _createVNode(_component_el_image, {
                        src: item.url,
                        fit: 'contain',
                        class: "elImg"
                      }, null, 8, ["src"]),
                      _createElementVNode("span", {
                        class: "clearImg",
                        onClick: ($event: any) => (_ctx.clearImage2(index))
                      }, "删除图片", 8, _hoisted_3)
                    ]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"]),
              _createVNode(_component_el_upload, {
                "file-list": _ctx.fileList2,
                action: _ctx.UpdateApi,
                "on-success": _ctx.handleAvatarSuccess2,
                "before-upload": _ctx.beforeAvatarUpload2,
                "show-file-list": false,
                "list-type": "picture-card",
                style: {"margin-top":"10px","margin-left":"10px"}
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_icon, { class: "avatar-uploader-icon" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_Plus)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["file-list", "action", "on-success", "before-upload"])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["model", "rules"])
    ]),
    _createVNode(_component_Map, {
      isShow: _ctx.isShow,
      onOnMapClose: _ctx.handleCloseMap,
      onOnSubmit: _ctx.handleSubmit
    }, null, 8, ["isShow", "onOnMapClose", "onOnSubmit"])
  ]))
}